<template>
    <div style="
        background: linear-gradient(
          135deg,
          rgb(25 115 165),
          rgb(20 145 215),
          #0d67aa,
          #00304e
        );
      ">
        <v-list>
            <v-list-item link>
                <v-list-item-content>
                    <v-list-item-title class="text-h6"> CNSR </v-list-item-title>
                    <v-list-item-subtitle>ESSALUD</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ nombre }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list nav dense>
            <v-list-item-group color="primary">
                <div v-for="(item, i) in itemsMenu" :key="i">
                    <router-link v-if="!item.children" :key="i" :to="item.route" exact>
                        <v-list-item :class="{
                            'v-list-item-navbar': true,
                            'v-list-item--active': isExactActive(item.route),
                        }">
                            <v-list-item-icon>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <v-list-group :value="isGroupActive(item.children)" :prepend-icon="item.icon" v-if="item.children"
                        style="color: #ffff !important" color="#ffff">
                        <template v-slot:activator>
                            <v-list-item-title style="color: #ffff !important" color="#ffff">{{ item.text
                                }}</v-list-item-title>
                        </template>
                        <div class="ml-6">
                            <router-link v-for="(child, j) in item.children" :key="j" :to="child.route" exact>
                                <v-list-item :class="{
                                    'v-list-item-navbar': true,
                                    'v-list-item--active': isExactActive(child.route),
                                }">
                                    <v-list-item-icon>
                                        <v-icon>{{ child.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ child.text }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </router-link>
                        </div>
                    </v-list-group>
                </div>
            </v-list-item-group>
        </v-list>
    </div>
</template>
<style scoped src="./style.css">
</style>
<script>
import Swal from "sweetalert2";
import { mapState } from "vuex";
export default {
    name: "navBarV",
    props: ["selectedItemBar","itemsMenu"],
    data() {
        return {
            openGroups: [],
            status: false,
            selectedItem: null,
            itemModalidad: null,
            itemPeriodo: null,
        };
    },
    watch: {
        $route() {
            // Fuerza la actualización del componente cuando la ruta cambia
            this.$forceUpdate();
        },
    },
    computed: {
        
    },
    methods: {
        isExactActive(route) {
            return this.$route.path === route;
        },
        isGroupActive(children) {
            return children.some((child) => this.$route.path.startsWith(child.route));
        },
    },
    created() {
        this.perfil = sessionStorage.getItem("perfil");
        this.nombre = sessionStorage.getItem("nombre");
        console.log("menu que se imprime",this.itemsMenu);
    },
};
</script>